<template>
	<Modal 
	:loading="loading" 
	:title="'MOTORISTA'"
	@close="close"
	@save="save">

		<div class="row">
			<div class="col-xs">
				<FormInput type="text" v-model="document" label="CPF/CNPJ" icon="fa-id-card" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput type="text" v-model="name" label="Nome" icon="fa-user" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput type="text" v-model="email" label="E-mail" icon="fa-envelope" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput type="text" v-model="phone" label="Telefone" icon="fa-phone-square-alt" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput type="text" v-model="password" label="Senha (deixe em branco para manter)" icon="fa-lock" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormCheckbox v-model="status" label="Status" icon="fa-check" />
			</div>
		</div>

	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from '@/components/FormInput';
import FormCheckbox from '@/components/FormCheckbox';
import Modal from '@/components/Modal';

export default {
	name: "AdminDriversForm",

	props: [ "current" ],

	components: { Modal, FormInput, FormCheckbox },

	data: function() {
		return {
			loading: false,

			document: this.current.document,
			password: '',
			name: this.current.name,
			email: this.current.email,
			phone: this.current.phone,
			status: this.current.status
		};
	},

	methods: {
		save: async function() {
			let delta = {};

			if (this.document != this.current.document) delta.document = this.document;

			if (this.name != this.current.name) delta.name = this.name;
			if (this.email != this.current.email) delta.email = this.email;
			if (this.phone != this.current.phone) delta.phone = this.phone;
			if (this.status != this.current.status) delta.status = this.status;
			if (this.password != '') delta.password = this.password;

			if (Object.keys(delta).length == 0) {
				this.close();
				return;
			}

			delta.id = this.current.id;

			this.loading = true;
			let res = await Api.post_admin("driver/save", delta);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$notification.success("Salvo com sucesso.");
			this.close();
			this.$parent.load();
		},

		close: function() {
			this.$parent.current = false;
		}
	}
}
</script>

<style scoped>
	
</style>